module.exports = __webpack_public_path__ + "img/open_side.fe01a950.svg";